import React from "react";
import css from "./CalculatedResult.module.css";
import CalculatedResultList from "./CalculatedResultList";
import Map from "../Map/Map";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import { useHistory } from "react-router-dom";
import Banner from "../Banner/Banner"

const Result = (props) => {
  let history = useHistory();
  const clickBackButtonHandle = () => {
    history.push("/");
  };
  return (
    <div className={css.ResultContainer}>
      <div className={css.BackButtonContainer}>
        <IconButton color="secondary" aria-label="Volver" onClick={clickBackButtonHandle} >
          <ArrowBackIcon fontSize="large"/>
        </IconButton>
          <h2>Tarifa Calculada</h2>
      </div>


      <div className={css.DataContainer}>
        <CalculatedResultList origin={props.result.origin} destiny={props.result.destiny} price={props.result.price}></CalculatedResultList>
      <Banner state="warning">El Precio puede Variar Por Tiempo de Espera, Paradas o por Modificación de Reorrido. El valor a Pagar es el que indica el reloj Taximetro.</Banner>

      </div>

      <div className={css.MapContainer}>
        <h4 className={css.Title}>Mapa Origen</h4>
        <span className={css.MapStreenDetail}>
          {props.result.origin.calle} {props.result.origin.numero}
        </span>
        <Map
          image={`http://138.121.161.214:46000/minimap/staticmap?size=800x800&center=${props.result.originLatLng.latitud},${props.result.originLatLng.longitud}&zoom=16`}
        ></Map>
        <h4 className={css.Title}>Mapa Destino</h4>
        <span className={css.MapStreenDetail}>
          {props.result.destiny.calle} {props.result.destiny.numero}
        </span>
        <Map
          image={`http://138.121.161.214:46000/minimap/staticmap?size=800x800&center=${props.result.destinyLatLng.latitud},${props.result.destinyLatLng.longitud}&zoom=16`}
        ></Map>
      </div>
    </div>
  );
};

export default Result;
/** 
 * 
 * 
 * Distancia: 19275
Duracion: "38 min"
Importe: "661.00"
ImporteMax: "753.00"
ImporteMaxNocturno: "904.00"
ImporteNocturno: "794.00"
*/
